import { CommonModule } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { ApiRequestService, DialogComponent, DialogConfiguration, DialogService, ListViewComponent, TranslationPipe } from '@prekog/common-ui';
import { Category } from '../shared/models/category.model';
import { GetCategoriesResponse } from './model/get-categories.response';
import { RemoveCategoryRequest } from './model/remove-category.request';

@Component({
    selector: 'app-categories',
    templateUrl: './categories.component.html',
    styleUrls: ['../packages/packages.component.scss'],
    standalone: true,
    imports: [MatIconModule, CommonModule, FormsModule, RouterModule, ListViewComponent, TranslationPipe]
})
export class CategoriesComponent implements OnInit {
    categories: Category[] = [];
    filteredCategories: Category[] = [];
    searchText = '';

    private _getCategoriesUrl = '/store/getCategories';
    private _deleteCategoryUrl = '/admin/delete-category';
    private _storeBaseUrl = inject('STORE_BACKEND_URL' as any) as string;
    private _apiRequestService = inject(ApiRequestService);
    private _dialogService = inject(DialogService);
    private _router = inject(Router);

    ngOnInit(): void {
        if (!sessionStorage.getItem('token')) {
            this._router.navigateByUrl('/');
        } else {
            this._apiRequestService
                .sendRequest<{}, GetCategoriesResponse>(this._storeBaseUrl, {}, true, this._getCategoriesUrl)
                .subscribe((response) => {
                    this.categories = response.categoryList!;
                    this.filteredCategories = this.categories;
                });
        }
    }

    openDeleteCategoryDialog(category: Category): void {
        const dialogConfiguration: DialogConfiguration = {
            messageKey: 'categories.deleteConfirmMessage',
            targetData: category.name
        }
        this._dialogService.openDialog(
            DialogComponent,
            dialogConfiguration,
            () => {
                this._deleteCategory(category.id!);
            }
        )
    }

    private _deleteCategory(categoryId: number): void {
        const removeCategoryRequest: RemoveCategoryRequest = {
            categoryId: categoryId
        };

        this._apiRequestService
            .sendRequest<
                RemoveCategoryRequest,
                HttpResponse<any>
            >(this._storeBaseUrl, removeCategoryRequest, true, this._deleteCategoryUrl, true)
            .subscribe({
                next: () => {
                    this.categories = this.categories.filter(
                        (category) => category.id !== categoryId
                    );
                    this.filteredCategories = this.categories;
                }
            });
    }
}
